import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import { useState } from 'react';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import ApiDatabase from '../../../../../server';
import Button from '../../../../button';
import { toast } from 'react-toastify';

const ModalInvoiceImportGlobal = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const invoices = modalData?.invoices || [];
  const year = modalData?.year || '';
  const month = modalData?.month || '';
  const preSelected = modalData?.preSelected || false;

  const toImportIds = invoices
    .filter((inv) => inv.status === 'not_imported')
    .map((inv) => inv.invoice_number);

  const allIds = invoices.map((inv) => inv.invoice_number);

  const [filter, setFilter] = useState(preSelected ? 'all' : 'to_import');
  const [selectedIds, setSelectedIds] = useState(preSelected ? allIds : toImportIds);
  const [pennylaneIds, setPennylaneIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const allSelected =
    selectedIds.length === invoices.length && invoices.length > 0;

  const allPennylaneSelected =
    selectedIds.length > 0 && selectedIds.every((id) => pennylaneIds.includes(id));

  const handleFilterAll = () => {
    setFilter('all');
    setSelectedIds(invoices.map((inv) => inv.invoice_number));
  };

  const handleFilterToImport = () => {
    setFilter('to_import');
    setSelectedIds(toImportIds);
  };

  const handleToggleAll = () => {
    setSelectedIds(
      allSelected ? [] : invoices.map((inv) => inv.invoice_number)
    );
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleToggleAllPennylane = () => {
    setPennylaneIds(allPennylaneSelected ? [] : [...selectedIds]);
  };

  const handleTogglePennylane = (id) => {
    setPennylaneIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleConfirm = () => {
    if (selectedIds.length === 0) return;
    setIsLoading(true);

    const plIds = pennylaneIds.filter((id) => selectedIds.includes(id));

    ApiDatabase.importInvoices(
      {
        token,
        year,
        month,
        paid: true,
        invoice_numbers: selectedIds,
        pennylane_invoice_numbers: plIds.length > 0 ? plIds : undefined,
      },
      () => {
        setIsLoading(false);
        let msg = `Import lancé pour ${selectedIds.length} facture(s).`;
        if (plIds.length > 0) msg += ` ${plIds.length} seront aussi envoyée(s) sur PennyLane.`;
        toast.success(msg);
        setModalDataReturn({
          action: 'invoices_imported',
          invoice_numbers: selectedIds,
        });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Une erreur est survenue.');
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Import global - Factures clients {year}/{month}
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4 text-sm">
          <div>
            <strong>{invoices.length}</strong> facture(s) concernée(s) -{' '}
            <strong>{selectedIds.length}</strong> sélectionnée(s)
            {pennylaneIds.filter((id) => selectedIds.includes(id)).length > 0 && (
              <span className="ml-2 text-blue-600">
                ({pennylaneIds.filter((id) => selectedIds.includes(id)).length} vers PennyLane)
              </span>
            )}
          </div>

          {!preSelected && (
            <div className="flex gap-2">
              <button
                className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-colors ${
                  filter === 'to_import'
                    ? 'bg-yellow-500 text-white'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-yellow-50'
                }`}
                onClick={handleFilterToImport}
              >
                À importer ({toImportIds.length})
              </button>
              <button
                className={`px-3 py-1.5 rounded-lg border text-sm font-medium transition-colors ${
                  filter === 'all'
                    ? 'bg-yellow-500 text-white'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-yellow-50'
                }`}
                onClick={handleFilterAll}
              >
                Tous ({invoices.length})
              </button>
            </div>
          )}

          <div className="border rounded">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="p-2 text-left">
                    <input
                      type="checkbox"
                      className="checkbox-primary"
                      checked={allSelected}
                      onChange={handleToggleAll}
                    />
                  </th>
                  <th className="p-2 text-left">N° Facture</th>
                  <th className="p-2 text-left">Entreprise</th>
                  <th className="p-2 text-right">Montant</th>
                  <th className="p-2 text-left">Statut</th>
                  <th className="p-2 text-center">
                    <label className="flex items-center gap-1 cursor-pointer">
                      <span>PennyLane</span>
                      <input
                        type="checkbox"
                        className="checkbox-primary"
                        checked={allPennylaneSelected}
                        onChange={handleToggleAllPennylane}
                      />
                    </label>
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv) => {
                  const isSelected = selectedIds.includes(inv.invoice_number);
                  return (
                    <tr
                      key={inv.invoice_number}
                      className="border-t border-gray-100 hover:bg-gray-50"
                    >
                      <td className="p-2">
                        <input
                          type="checkbox"
                          className="checkbox-primary"
                          checked={isSelected}
                          onChange={() => handleToggleOne(inv.invoice_number)}
                        />
                      </td>
                      <td className="p-2">{inv.invoice_number}</td>
                      <td className="p-2">{inv.company_name}</td>
                      <td className="p-2 text-right">
                        {inv.amount ? `${Number(inv.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
                      </td>
                      <td className="p-2">
                        {inv.status === 'imported' ? (
                          <span className="text-green-700 bg-green-100 px-2 py-0.5 rounded text-xs">
                            Importé
                          </span>
                        ) : (
                          <span className="text-gray-700 bg-gray-100 px-2 py-0.5 rounded text-xs">
                            Non importé
                          </span>
                        )}
                      </td>
                      <td className="p-2 text-center">
                        <input
                          type="checkbox"
                          checked={pennylaneIds.includes(inv.invoice_number)}
                          onChange={() => handleTogglePennylane(inv.invoice_number)}
                          disabled={!isSelected}
                          className="checkbox-primary"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <div className="flex gap-2">
            <Button size="LG" color="DISABLED">
              Annuler
            </Button>
            <Button size="LG" color="DISABLED">
              Confirmer ...
            </Button>
          </div>
        ) : (
          <div className="flex gap-2">
            <Button onClick={toggle} size="LG" color="SECONDARY">
              Annuler
            </Button>
            <Button
              onClick={handleConfirm}
              size="LG"
              disabled={selectedIds.length === 0}
            >
              Confirmer ({selectedIds.length})
            </Button>
          </div>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalInvoiceImportGlobal;
